import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { TextOrTranslation } from '../..'
import { getColumnKey, getRowKey } from '../../../utils/componentHelper'
import { DenseTableRowProps, CellProps, ContentProps } from '../types'
import { CellContent } from './cell-content'

export const DesktopContent = <RowDataType,>({
  data,
  filtered,
  ...rest
}: ContentProps<RowDataType>) => {
  return (
    <Table size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
          {filtered.map((cell: CellProps<RowDataType>, index: number) => (
            <TableCell key={getRowKey('H', index)} width={cell.columnWidth}>
              <TextOrTranslation
                text={cell.label}
                translationId={cell.labelTranslationId}
              />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row: DenseTableRowProps<RowDataType>, rowIndex: number) => {
          return (
            <TableRow
              key={getRowKey('R', rowIndex)}
              sx={{
                backgroundColor: (theme) =>
                  row.addAlertClass
                    ? theme.variables.colors.table.alert
                    : undefined,
                '& td:first-of-type': {
                  paddingLeft: row.addAlertClass ? '2px' : undefined
                },
                minHeight: '40px'
              }}
            >
              {filtered.map(
                (cellProps: CellProps<RowDataType>, cellIndex: number) => {
                  return (
                    <TableCell
                      key={getColumnKey('C', rowIndex, cellIndex)}
                      align="left"
                      width={cellProps.columnWidth}
                    >
                      <CellContent
                        {...{ ...rest, index: rowIndex }}
                        isMobile={false}
                        row={row}
                        cellProps={cellProps}
                      />
                    </TableCell>
                  )
                }
              )}
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
